import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n  cursor: pointer;\n  font-size: 10px;\n  margin: 5px;\n  text-transform: uppercase;\n'], ['\n  color: ', ';\n  cursor: pointer;\n  font-size: 10px;\n  margin: 5px;\n  text-transform: uppercase;\n']);

import styled from 'styled-components';

export var StyledBtn = styled.button(_templateObject, function (props) {
  return props.theme.dormifyPink;
});